import { useCallback, useEffect, useMemo } from 'react';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import { Box, Grid, TextField } from '@mui/material';
import SearchCompanyField from '../SearchCompanyField';
import { MixpanelWrapper } from '../MixPanelWrapper';
import CreateQuoteCardHeader from '../CreateQuoteCardHeader';
import CreateQuoteSectionTitle from '../CreateQuoteSectionTitle';
import { RatingRegionsTable } from '../RatingRegionsTable';
import { useQuoteContext } from '../../shared/contexts/QuoteContext';
import { useGetClientByABNQuery } from '../../services/features/clientApi/clientApi';
import SearchOccupationField from '../SearchOccupationField';
import { AddressFields } from '../AddressFields';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { ClientEntityGroupSelect } from '../ClientEntityGroupSelect';

/**
 * ClientDetailForm is a React component used for displaying and collecting details about a client.
 *
 * @param {Object} props - The component's props.
 * @param {Object} props.options - Formik options/values
 * @returns {JSX.Element} The JSX element for rendering ClientDetailForm.
 */
const ClientDetailForm = (props: any) => {
	const { quoteGroup, ratingRegionsRows } = useQuoteContext();

	const formik = props.options;

	// const businessNumber = useMemo(() => formik?.values?.businessNumber, [formik]);

	// const clientAbnQuery = useGetClientByABNQuery(businessNumber ?? skipToken, { skip: !businessNumber });

	// useEffect(() => {
	// 	if (clientAbnQuery.data) {
	// 		const client = clientAbnQuery.data;
	//         console.log("CLIENT", client);
	// 		let newName =
	// 			client?.organizationName ??
	// 			client?.fullName ??
	// 			`${client?.givenName} ${client?.familyName}`;
	// 		const newValues = {
	// 			...formik.values,
	// 			companyName: newName,
	// 			...(!quoteGroup && {
	// 				streetName: client?.addressLine1 ?? "",
	// 				city: client?.addressLine2 ?? "",
	// 				postcode: client?.postcode ?? "",
	// 				region: client?.stateCode ?? "",
	// 			}),
	//             entityCode: client?.type ?? "",
	// 		};
	// 		formik.setValues(newValues);
	// 	} else if (!quoteGroup) {
	//         formik.setFieldValue('businessNumber', null);
	//         formik.setFieldValue('companyName', '');
	//     }
	// }, [clientAbnQuery.data]);

	useEffect(() => {
		const totalsRow = ratingRegionsRows.find((r) => r.name.toLowerCase() === 'total');
		if (totalsRow) {
			const { lastYearAmount, currentYearAmount, staffNumbers } = totalsRow;
			formik.setFieldValue('totals', [
				parseInt(`${lastYearAmount ?? 0}`),
				parseInt(`${currentYearAmount ?? 0}`),
				parseInt(`${staffNumbers ?? 0}`),
			]);
		}
	}, [ratingRegionsRows]);

	useEffect(() => {
		MixpanelWrapper.track('Create Quote - Client Details');
	}, []);

	return (
		<div className='clientDetailForm_container'>
			<CreateQuoteCardHeader title={'Client Details'} />
			<CardContent>
				<Box pb='2em'>
					<Typography variant='cardContentHeader'>
						Please provide the insured's details to view available products
					</Typography>
				</Box>
				<Grid container spacing={3}>
					{!quoteGroup && (
						<Grid item xs={12}>
							<ClientEntityGroupSelect options={formik} />
						</Grid>
					)}

					<Grid item xs={12}>
						{quoteGroup ? (
							<>
								<CreateQuoteSectionTitle title={'Client Name'} />
								<TextField value={formik.values.companyName} fullWidth disabled />
							</>
						) : (
							<>
								<SearchCompanyField options={formik} />
							</>
						)}
					</Grid>
					<Grid item xs={12}>
						<CreateQuoteSectionTitle
							title={"What is the insured's address"}
							tooltip={'This is the main/head office of the insured.'}
							variant='cardContentHeader'
						/>
						<Box py='1em'>
							<AddressFields options={formik} />
						</Box>
					</Grid>
					<Grid item xs={12}>
						<SearchOccupationField options={formik} />
					</Grid>
					<Grid item xs={12}>
						<CreateQuoteSectionTitle
							title={
								"Please provide the insured's turnover and employee breakdown by state"
							}
							variant='cardContentHeader'
						/>
						<RatingRegionsTable
							setFieldTouched={() => formik.setFieldTouched('totals', true)}
							error={Boolean(formik.touched.totals && Boolean(formik.errors.totals))}
						/>
						{Boolean(formik.touched.totals && formik.errors.totals) && (
							<FormHelperText error>{formik.errors.totals}</FormHelperText>
						)}
					</Grid>
				</Grid>
			</CardContent>
		</div>
	);
};

export default ClientDetailForm;
